<template>
    <div class="tile-content">
        <div class="grid-content">
            <div class="grid-item grid-item-half grid-item-break-half">
                <v-checkbox
                    label="Send me an email when the export is ready"
                    :value="true"
                    :selected="isEnabled"
                    @input="toggleEmailNotification"/>
            </div>
            <div
                v-if="isEnabled"
                class="grid-item grid-item-full">
                <r-input
                    label="Send email to"
                    help-text="Add multiple emails, comma (,) separated."
                    :auto-focus="true"
                    :value="emailNotificationStringValue"
                    @input="updateEmail"/>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        vCheckbox, vIcon, vIconButton,
    } from '@/components/form';
    import _ from '@/common/helpers';

    export default {
        name: 'email-notifications-form',
        components: {
            vCheckbox,
            vIconButton,
            vIcon,
        },
        props: {
            emailNotification: {
                validator: value => value === null || Array.isArray(value),
                required: true,
            },
            isEnabled: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            emailNotificationStringValue() {
                return this.emailNotification ? this.emailNotification.join(', ') : '';
            },
        },
        methods: {
            toggleEmailNotification(notificationIsEnabled) {
                this.$emit('update', notificationIsEnabled ? [] : null);
            },
            updateEmail(value) {
                const emailNotification = value
                    ? _.getCommaSeparated(value)
                    : null;
                this.$emit('update', emailNotification);
            },
        },
    };
</script>
